/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AcceptInvitationRequestDto from '../model/AcceptInvitationRequestDto';
import ErrorDto from '../model/ErrorDto';
import InvitedUserInfoDto from '../model/InvitedUserInfoDto';
import SendInvitationRequestDto from '../model/SendInvitationRequestDto';
import UserInvitationDto from '../model/UserInvitationDto';

/**
* UserInvitation service.
* @module api/UserInvitationApi
* @version v0
*/
export default class UserInvitationApi {

    /**
    * Constructs a new UserInvitationApi. 
    * @alias module:api/UserInvitationApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the acceptInvitation operation.
     * @callback module:api/UserInvitationApi~acceptInvitationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserInvitationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Accept an invitation using the token from email
     * @param {module:model/AcceptInvitationRequestDto} acceptInvitationRequestDto 
     * @param {module:api/UserInvitationApi~acceptInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserInvitationDto}
     */
    acceptInvitation(acceptInvitationRequestDto, callback) {
      let postBody = acceptInvitationRequestDto;
      // verify the required parameter 'acceptInvitationRequestDto' is set
      if (acceptInvitationRequestDto === undefined || acceptInvitationRequestDto === null) {
        throw new Error("Missing the required parameter 'acceptInvitationRequestDto' when calling acceptInvitation");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserInvitationDto;
      return this.apiClient.callApi(
        '/api/private/invitations/accept', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the cancelInvitation operation.
     * @callback module:api/UserInvitationApi~cancelInvitationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Cancel/delete an invitation (only by inviter)
     * @param {Number} id 
     * @param {module:api/UserInvitationApi~cancelInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    cancelInvitation(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling cancelInvitation");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/invitations/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getInvitedUsers operation.
     * @callback module:api/UserInvitationApi~getInvitedUsersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InvitedUserInfoDto>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of users who accepted invitations from the authenticated user
     * @param {module:api/UserInvitationApi~getInvitedUsersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InvitedUserInfoDto>}
     */
    getInvitedUsers(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InvitedUserInfoDto];
      return this.apiClient.callApi(
        '/api/private/invitations/invited-users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getSentInvitations operation.
     * @callback module:api/UserInvitationApi~getSentInvitationsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserInvitationDto>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all invitations sent by the authenticated user
     * @param {module:api/UserInvitationApi~getSentInvitationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserInvitationDto>}
     */
    getSentInvitations(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [UserInvitationDto];
      return this.apiClient.callApi(
        '/api/private/invitations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the rejectInvitation operation.
     * @callback module:api/UserInvitationApi~rejectInvitationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserInvitationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reject an invitation using the token from email
     * @param {String} token 
     * @param {module:api/UserInvitationApi~rejectInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserInvitationDto}
     */
    rejectInvitation(token, callback) {
      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling rejectInvitation");
      }

      let pathParams = {
      };
      let queryParams = {
        'token': token
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = UserInvitationDto;
      return this.apiClient.callApi(
        '/api/private/invitations/reject', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the sendInvitation operation.
     * @callback module:api/UserInvitationApi~sendInvitationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserInvitationDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send invitation to another user by email (requires role_id=3)
     * @param {module:model/SendInvitationRequestDto} sendInvitationRequestDto 
     * @param {module:api/UserInvitationApi~sendInvitationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserInvitationDto}
     */
    sendInvitation(sendInvitationRequestDto, callback) {
      let postBody = sendInvitationRequestDto;
      // verify the required parameter 'sendInvitationRequestDto' is set
      if (sendInvitationRequestDto === undefined || sendInvitationRequestDto === null) {
        throw new Error("Missing the required parameter 'sendInvitationRequestDto' when calling sendInvitation");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UserInvitationDto;
      return this.apiClient.callApi(
        '/api/private/invitations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
